###
@deprecated Use AbstractController instead
###
class @BaseController
	autoScopeInject: true

	@inject '$scope', 'Guid'

	@register: (module, name) ->
		name ?= @name || @toString().match(/function\s*(.*?)\(/)?[1]
		module.controller name, @

	# Build DI array to later inject to constructor
	@inject: ->
		@$inject = _.union(@$inject, arguments)

	constructor: ->
		for key, index in @constructor.$inject
			@[key] = arguments[index]

		if @autoScopeInject
			@_getAllMethodNames().forEach (key) =>
				fn = @[key]

				if typeof fn == 'function'
					# Copy class methods to $scope
					# Alternative to controllerAs syntax
					@$scope[key] = fn.bind?(@) || _.bind(fn, @)

				return true

		# Make alias for mainCrud in controller
		if angular.isDefined(@$scope.mainCrud)
			@mainCrud = @$scope.mainCrud

		@controllerId = @Guid.randomString()

	$onInit: ->
		resetForm = =>
			@$scope.parent_form?.$setPristine()
			@$scope.parent_form?.$setUntouched()
			@$scope.main_form?.$setPristine()
			@$scope.main_form?.$setUntouched()

		@$scope.$on 'RemoveButtonPushed', => resetForm()
		@$scope.$on 'SavedButtonPushed', => resetForm()

		@initialize?()

	##
	# In ES6 class properties can't be enumerable, so we must use getOwnPropertyNames instead
	# @see https://stackoverflow.com/a/45374416/1346234
	# Recursively gather methods from prototypes
	##
	_getAllMethodNames: ->
		obj = @
		methods = new Set()

		loop
			obj = Reflect.getPrototypeOf obj

			break if not obj
			break if obj.constructor.name == (new Object()).constructor.name

			keys = Reflect.ownKeys(obj)

			keys.forEach (key) =>
				methods.add(key) unless key in ['constructor', 'initialize'] or key[0] == '_'

		return methods

	addErrorMessage: (key, value) ->
		do @resetErrors if !@$scope.errorMessages?
		@$scope.errorMessages[key] = value

	handleErrors: (response) ->
		do @resetErrors

		if !response?
			return

		if response.errors?
			angular.forEach response.errors, (error, key) =>
				@addErrorMessage key, if angular.isArray error then error[0] else error

	resetErrors: ->
		@$scope.errorMessages = {}
